var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackedBarChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Widget/VertBar/KeyMetricsTrend/Simplified") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Widget/VertBar/KeyMetricsTrend/Simplified",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: 4,
    fill: "#999999",
    mask: "url(#mask-2)",
    x: 160.840442,
    y: 103,
    width: 17.8579882,
    height: 22,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8404416,90.996524 C85.8404416,89.3415895 87.1826932,88 88.8496121,88 L100.689259,88 C102.351178,88 103.69843,89.3387083 103.69843,90.996524 L103.69843,122.003476 C103.69843,123.658411 102.356178,125 100.689259,125 L88.8496121,125 C87.1876931,125 85.8404416,123.661292 85.8404416,122.003476 L85.8404416,90.996524 Z",
    id: 3,
    fill: "#999999",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84044159,100.992634 C9.84044159,99.3398479 11.1826932,98 12.8496121,98 L24.6892592,98 C26.3511782,98 27.6984298,99.3389342 27.6984298,100.992634 L27.6984298,122.007366 C27.6984298,123.660152 26.3561782,125 24.6892592,125 L12.8496121,125 C11.1876931,125 9.84044159,123.661066 9.84044159,122.007366 L9.84044159,100.992634 Z",
    id: 2,
    fill: "#999999",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: 4,
    fill: "#668DCC",
    mask: "url(#mask-2)",
    x: 179.888962,
    y: 85,
    width: 17.8579882,
    height: 40,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: 3,
    fill: "#668DCC",
    mask: "url(#mask-2)",
    x: 104.888962,
    y: 103,
    width: 17.8579882,
    height: 22,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8889623,95.9961002 C28.8889623,94.3413998 30.2312139,93 31.8981328,93 L43.7377799,93 C45.3996989,93 46.7469505,94.3342595 46.7469505,95.9961002 L46.7469505,122.0039 C46.7469505,123.6586 45.4046989,125 43.7377799,125 L31.8981328,125 C30.2362138,125 28.8889623,123.66574 28.8889623,122.0039 L28.8889623,95.9961002 Z",
    id: 2,
    fill: "#668DCC",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: 4,
    fill: "#F46814",
    mask: "url(#mask-2)",
    x: 198.937483,
    y: 48,
    width: 17.8579882,
    height: 77,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: 3,
    fill: "#F46814",
    mask: "url(#mask-2)",
    x: 123.937483,
    y: 14,
    width: 17.8579882,
    height: 111,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: 2,
    fill: "#F46814",
    mask: "url(#mask-2)",
    x: 47.937483,
    y: 35,
    width: 17.8579882,
    height: 90,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Trend-Line",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 3.283784)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-46",
    fill: "#666666",
    fillRule: "nonzero",
    points: "37.754 30.516 114.032814 1.94449442 189.047 32.273 235 15.7858297 235 19.0593488 188.982707 35.4830428 113.991 5.163 37.8809253 33.6727858 0 22.9726856 0 19.4983733"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(185.200117, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88106509,0 C1.73799089,0 0,1.73602981 0,3.87837838 C0,6.02072695 1.73799089,7.75675676 3.88106509,7.75675676 C6.02413928,7.75675676 7.76213018,6.02072695 7.76213018,3.87837838 C7.76213018,1.73602981 6.02413928,0 3.88106509,0 Z",
    id: "Path",
    fill: "#666666",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88106509,3 C4.36804277,3 4.76213018,3.39364274 4.76213018,3.87837838 C4.76213018,4.36311402 4.36804277,4.75675676 3.88106509,4.75675676 C3.39408741,4.75675676 3,4.36311402 3,3.87837838 C3,3.39364274 3.39408741,3 3.88106509,3 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(110.200117, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88106509,0 C1.73799089,0 0,1.73602981 0,3.87837838 C0,6.02072695 1.73799089,7.75675676 3.88106509,7.75675676 C6.02413928,7.75675676 7.76213018,6.02072695 7.76213018,3.87837838 C7.76213018,1.73602981 6.02413928,0 3.88106509,0 Z",
    id: "Path",
    fill: "#666666",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88106509,3 C4.36804277,3 4.76213018,3.39364274 4.76213018,3.87837838 C4.76213018,4.36311402 4.36804277,4.75675676 3.88106509,4.75675676 C3.39408741,4.75675676 3,4.36311402 3,3.87837838 C3,3.39364274 3.39408741,3 3.88106509,3 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(33.200117, 29.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88106509,0 C1.73799089,0 0,1.73602981 0,3.87837838 C0,6.02072695 1.73799089,7.75675676 3.88106509,7.75675676 C6.02413928,7.75675676 7.76213018,6.02072695 7.76213018,3.87837838 C7.76213018,1.73602981 6.02413928,0 3.88106509,0 Z",
    id: "Path",
    fill: "#666666",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88106509,3 C4.36804277,3 4.76213018,3.39364274 4.76213018,3.87837838 C4.76213018,4.36311402 4.36804277,4.75675676 3.88106509,4.75675676 C3.39408741,4.75675676 3,4.36311402 3,3.87837838 C3,3.39364274 3.39408741,3 3.88106509,3 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedBarChart);
export default __webpack_public_path__ + "static/media/stacked-bar-chart.5e73ece1825dc0f8b69724785a39d1f3.svg";
export { ForwardRef as ReactComponent };